module.exports = __webpack_public_path__ + "img/55_9.1d2f2c90.png";